import { IBoundary } from '../hooks/fishrules/useRegulationBoundaryAtLocation';

function isProhibitedRank(rank: number): boolean {
  // eslint-disable-next-line no-magic-numbers
  return rank >= 250 && rank <= 255;
}

export function isProhibitedLocation(boundaries: IBoundary[]): {
  isProhibited: boolean;
  message?: string;
} {
  const prohibitedBoundary = boundaries.find(b => b.prohibited || isProhibitedRank(b.rank));

  if (prohibitedBoundary) {
    return { isProhibited: true, message: prohibitedBoundary.prohibitedMessage };
  }

  return { isProhibited: false };
}
